const state = {
    search: '[]',
    worksReload: false
}

const getters = {
    getSearch(state: any) {
        return state.search;
    },
    getWorksReload(state: any) {
        return state.worksReload;
    }
}

const actions = {
    setSearch(store: any, json: string) {
        return new Promise((resolve) => {
            store.commit('setSearch', json);
            resolve(true);
        });
    },
    async setWorksReload(store: any, flg: boolean) {
        store.commit('setWorksReload', flg);
        return true;
    }
}

const mutations = {
    setSearch(state: any, json: string) {
        state.search = json;
    },
    setWorksReload(state: any, flg: boolean) {
        state.worksReload = flg;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
